<template>
  <base-dialog show-close :visible.sync="visible" class="send-connect-request-dialog">
    <template v-slot:header>填写邀请码</template>
    <el-form ref="form" :model="form" label-width="110px" :rules="rules" label-position="left">
      <el-form-item label="邀请码" prop="code">
        <div style="display: flex;align-items: center;">
          <el-input v-model="form.code" style="flex: auto;"></el-input>
          <base-button @click="sendRequest" type="primary" style="flex: 0;margin-left: 10px;">
            发送邀请
          </base-button>
        </div>
      </el-form-item>
    </el-form>
    <template v-slot:footer>
      <span class="dialog-footer">
        <base-button @click="visible = false">取消</base-button>
        <base-button type="primary" @click="submit">确认</base-button>
      </span>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseButton from "@/components/UIComponents/Button"
import { completeCompanyConnect, sendCompanyConnectCode } from "@/api/connect"

export default {
  name: "send-connect-request-dialog",
  components: { BaseDialog, BaseButton },
  data() {
    return {
      visible: false,
      form: {
        code: ""
      },
      connectCompany: {},
      rules: {
        code: [{ required: true, message: "请填写邀请码", trigger: "blur" }]
      }
    }
  },
  methods: {
    open(connectCompany) {
      this.connectCompany = connectCompany ? this._.cloneDeep(connectCompany) : {}
      this.form.code = ""
      this.visible = true
    },
    sendRequest() {
      sendCompanyConnectCode(this.connectCompany.id).then(() => this.$message.success("发送成功"))
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        completeCompanyConnect(this.connectCompany.id, this.form.code).then(() => {
          this.$message.success("互联成功")
          this.$emit("change")
          this.visible = false
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.send-connect-request-dialog {
  ::v-deep .el-dialog {
    .el-dialog__body {
      padding: 18px 60px 8px 24px;
      color: unset;
    }
  }
}
</style>
